import { Type } from '@sinclair/typebox';
import { SupportedEvmNetworkSchema, SupportedNetwork, } from '../supported-network.js';
import { TokenModerationStatusSchema } from './token-moderation.js';
export const BuybotGroupInfoSchema = Type.Object({
    portalLink: Type.String({
        description: 'Telegram link',
    }),
    name: Type.String(),
    members: Type.Number(),
});
export const XUserPublicMetricsSchema = Type.Object({
    followersCount: Type.Number(),
    followingCount: Type.Number(),
    favouritesCount: Type.Number({
        description: 'Number of favorites',
    }),
    mediaCount: Type.Number({
        description: 'Number of media posts',
    }),
});
export const XUserInfoSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    username: Type.String(),
    description: Type.Optional(Type.String()),
    url: Type.String(),
    profileImageUrl: Type.Optional(Type.String()),
    profileBannerUrl: Type.Optional(Type.String()),
    verified: Type.Boolean(),
    createdAt: Type.String(),
    publicMetrics: XUserPublicMetricsSchema,
});
export const XTweetPublicMetricsSchema = Type.Object({
    likeCount: Type.Number({
        description: 'The number of times the tweet has been liked',
    }),
    retweetCount: Type.Number({
        description: 'The number of times the tweet has been retweeted',
    }),
    replyCount: Type.Number({
        description: 'The number of times the tweet has been replied to',
    }),
    bookmarkCount: Type.Number({
        description: 'The number of times the tweet has been bookmarked',
    }),
    viewCount: Type.Number({
        description: 'The number of times the tweet has been viewed',
    }),
    quoteCount: Type.Number({
        description: 'The number of times the tweet has been quoted',
    }),
});
export const XTweetMediaSchema = Type.Object({
    type: Type.Union([
        Type.Literal('photo'),
        Type.Literal('video'),
        Type.Literal('animated_gif'),
    ]),
    url: Type.Optional(Type.String()),
    previewImageUrl: Type.Optional(Type.String()),
    width: Type.Optional(Type.Number()),
    height: Type.Optional(Type.Number()),
    altText: Type.Optional(Type.String()),
});
export const XTweetInfoSchema = Type.Object({
    id: Type.String(),
    text: Type.String(),
    createdAt: Type.String(),
    publicMetrics: XTweetPublicMetricsSchema,
    author: XUserInfoSchema,
    media: Type.Optional(Type.Array(XTweetMediaSchema)),
});
export const XTokenCommunitySchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    description: Type.Optional(Type.String()),
    memberCount: Type.Number(),
    url: Type.String(),
});
export const TwitterInfoSchema = Type.Union([
    Type.Object({ type: Type.Literal('profile'), user: XUserInfoSchema }),
    Type.Object({ type: Type.Literal('tweet'), tweet: XTweetInfoSchema }),
]);
export const TokenSocailsSchema = Type.Object({
    website: Type.Optional(Type.String({
        description: 'Website link',
    })),
    discord: Type.Optional(Type.String({
        description: 'Discord link',
    })),
    twitter: Type.Optional(Type.Union([Type.String(), Type.Array(Type.String())])),
    telegram: Type.Optional(Type.Union([
        Type.String({
            description: 'Telegram link',
        }),
        Type.Array(BuybotGroupInfoSchema),
    ])),
    twitterInfo: Type.Optional(TwitterInfoSchema),
});
export const CommonTokenMetaSchemaExtended = Type.Object({
    address: Type.String(),
    name: Type.String(),
    symbol: Type.String(),
    decimals: Type.Number(),
    logo: Type.String(),
    status: TokenModerationStatusSchema,
    pair: Type.Optional(Type.String()),
    socials: Type.Optional(TokenSocailsSchema),
    supply: Type.String(),
    inTrends: Type.Optional(Type.Boolean()),
    trendingRank: Type.Optional(Type.Number()),
    imageHash: Type.Optional(Type.String({
        description: 'Perceptual dHash of the token logo (64-bit hex)',
    })),
    reusedImageCount: Type.Optional(Type.Number({
        description: 'Number of other tokens sharing the same logo image',
    })),
});
export const SolTokenMetaSchemaExtended = Type.Object({
    ...CommonTokenMetaSchemaExtended.properties,
    network: Type.Literal(SupportedNetwork.Sol),
    uri: Type.Optional(Type.String()),
    isRenounced: Type.Boolean(),
}, {
    title: 'SolTokenMeta',
    readOnly: true,
});
export const EvmTokenMetaSchemaExtended = Type.Object({
    ...CommonTokenMetaSchemaExtended.properties,
    network: SupportedEvmNetworkSchema,
}, {
    title: 'EthTokenMeta',
    readOnly: true,
});
export const TonTokenMetaSchemaExtended = Type.Object({
    ...CommonTokenMetaSchemaExtended.properties,
    network: Type.Literal(SupportedNetwork.Ton),
}, {
    title: 'TonTokenMeta',
    readOnly: true,
});
export const ExtendedTokenMetaSchema = Type.Union([
    SolTokenMetaSchemaExtended,
    EvmTokenMetaSchemaExtended,
    TonTokenMetaSchemaExtended,
], { title: 'ExtendedTokenMetaSchema' });
//# sourceMappingURL=token-meta-extended.js.map